import React, { JSX, useContext } from "react";
import { BenchmarkingFiltersContext } from "@app/overviews/network-benchmarking-dashboard/filters";
import { MedicareNetworkFilters, MedicarePrimaryFilters } from "@app/overviews/network-benchmarking-dashboard/medicare/filters";

const BenchmarkingFilters = (): JSX.Element => {
  const benchmarkingMedicareFiltersContext = useContext(BenchmarkingFiltersContext);

  return (
    <React.Fragment>
      {!benchmarkingMedicareFiltersContext.displayedPrimaryFilters && (
        <div className="row">
          <div className="col-12">
            <label className="copy-text-default mb-3">
              Please begin by selecting and applying your filters to view available networks for comparison.
            </label>
          </div>
        </div>
      )}

      <div className="row">
        <div className="col-12">
          <div className="card card-static">
            <div className="card-body">
              <MedicarePrimaryFilters />

              {!!benchmarkingMedicareFiltersContext.displayedPrimaryFilters && (
                <MedicareNetworkFilters />
              )}
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
    
  );
}

export default BenchmarkingFilters;